<template>
  <div class="reporting-component">
    <div class="row">
      <div class="col-sm-4">
        <vue-form ref="form"
          :options="{ permalink: 'accountReporting' }"
          @load="refresh()">
          <div class="card-header" slot="title">
            <span class="fa fa-users"></span>
            Account Reporting
          </div>
          <template slot="actions">
            <div class="col-sm-8 offset-sm-4">
              <button type="button" class="btn btn-default" @click="refresh()">
                <span class="fa fa-fw fa-sync"></span> Refresh
              </button>
              <button type="button" class="btn btn-primary" @click="send()">
                <span class="fa fa-paper-plane fa-fw"></span> Send
              </button>
            </div>
          </template>
        </vue-form>
      </div>
      <div class="col-sm-8">
        <div class="card card-primary">
          <div class="card-header">
            <span class="fa fa-fw fa-chart-bar"></span>
            Account Usage
          </div>
          <div class="card-body">
            <chart :data="this.revenueChart" title="Revenue" ref="revenue" type="line" :show-totals="false"></chart>
            <hr class="dark">
            <chart :data="this.distanceChart" title="Distance" ref="distance" type="line" :show-totals="false"></chart>
            <hr class="dark">
            <chart :data="this.tripsChart" title="Trips" ref="trips" type="line" :show-totals="false"></chart>
            <hr class="dark">
            <chart :data="this.cancellationChart" title="Quit Members" ref="cancellations" type="line" :show-totals="false"></chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Inputs
import VueForm from '@/components/Form'
import Api from '@/vuex/api'
import Chart from '@/components/Chart'

export default {
  name: 'AccountReporting',
  components: {
    Chart,
    VueForm
  },
  data () {
    return {
      rawData: {},
      revenueLabel: [
        { label: 'totalAmount', data: [], color: '75, 192, 192' }
      ],
      distanceLabel: [
        { label: 'distance', data: [], color: '255, 206, 86' }
      ],
      tripsLabel: [
        { label: 'numberOfTrips', data: [], color: '255, 99, 132' }
      ],
      cancellationLabel: [
        { label: 'quitMembers', data: [], color: '255, 30, 30' }
      ]
    }
  },
  computed: {
    revenueChart () {
      return this.revenueLabel.map(({ label, color }, i) => {
        let labels = []
        let data = []
        for (let date in this.rawData) {
          let obj = this.rawData[date]
          if (!labels.includes(date)) labels.push(date)
          if (obj[label]) data.push(obj[label])
          else data.push(0)
        }
        return {
          label: 'Revenue $',
          color,
          data,
          labels
        }
      })
    },
    distanceChart () {
      return this.distanceLabel.map(({ label, color }, i) => {
        let labels = []
        let data = []
        for (let date in this.rawData) {
          let obj = this.rawData[date]
          if (!labels.includes(date)) labels.push(date)
          if (obj[label]) data.push(obj[label])
          else data.push(0)
        }
        return {
          label: 'Distance (KM)',
          color,
          data,
          labels
        }
      })
    },
    tripsChart () {
      return this.tripsLabel.map(({ label, color }, i) => {
        let labels = []
        let data = []
        for (let date in this.rawData) {
          let obj = this.rawData[date]
          if (!labels.includes(date)) labels.push(date)
          if (obj[label]) data.push(obj[label])
          else data.push(0)
        }
        return {
          label: 'Total Trips',
          color,
          data,
          labels
        }
      })
    },
    cancellationChart () {
      return this.cancellationLabel.map(({ label, color }, i) => {
        let labels = []
        let data = []
        for (let date in this.rawData) {
          let obj = this.rawData[date]
          if (!labels.includes(date)) labels.push(date)
          if (obj[label]) data.push(obj[label])
          else data.push(0)
        }
        return {
          label: 'Total Cancellations',
          color,
          data,
          labels
        }
      })
    }
  },
  methods: {
    async refresh () {
      let instance = new Api()
      let formData = this.$refs.form.serializeForm()
      this.rawData = await instance.getAccountReporting(formData)
      await this.$nextTick()
      this.$refs.trips.refresh()
      this.$refs.revenue.refresh()
      this.$refs.distance.refresh()
      this.$refs.cancellations.refresh()
    },
    send () {
      this.$refs.form.submitForm()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Reporting.vue